export default function(array) {
  return array[array.length - 1];
}



// WEBPACK FOOTER //
// ./~/vega-util/src/peek.js